import React from 'react'
import InfoTemplate from 'containers/list/info_types/info_template'
import ProductDetailsPage from 'containers/list/info_types/product_details_page'

const ProductInfo = (props) => {
  const {product} = props
  const {info_type} = product

  if (info_type == 'info_template') {
    return <InfoTemplate {...props}/>
  } else if (info_type == 'product_details') {
    return <ProductDetailsPage {...props}/>
  } else {
    return <InfoTemplate {...props}/>
  }
}

export default ProductInfo
